import { DirectionEnum } from '../types/enums';
import { ActorRef, Vec2 } from '../data/cinematics/types';

export interface CinematicActor {
  getPosition(): Vec2;
  setPosition(p: Vec2): void;
  setFacing(dir: DirectionEnum): void;
  playWalk(): void;
  playIdle(): void;
}

export interface CinematicSceneAdapter {
  camera: {
    getPosition(): Vec2;
    setPosition(p: Vec2): void;
    getZoom(): number;
    setZoom(z: number): void;
    setFollow(actor: ActorRef | null): void;
  };
  getActor(ref: ActorRef): CinematicActor | null;
}

let current: CinematicSceneAdapter | null = null;

export function registerCinematicScene(adapter: CinematicSceneAdapter): void {
  current = adapter;
}

export function clearCinematicScene(adapter: CinematicSceneAdapter): void {
  if (current === adapter) {
    current = null;
  }
}

export function getCinematicScene(): CinematicSceneAdapter | null {
  return current;
}
